import React from 'react';
import styled from 'styled-components';
export const ScrollArea = (props) => {
    const { height, children } = props;
    return React.createElement(SScrollArea, { height: height }, children);
};
const SScrollArea = styled.div `
  overflow-y: scroll;
  height: ${({ height }) => height};
`;
